/* @flow */

import { encode } from './uri';
import { xhr as _xhr, xhrWithLinks as _xhrWithLinks, drainRequestQueue } from './xhr';
import config from '../config';
import { createNetworkError } from './network_error';

const [xhr,  xhrWithLinks] = typeof window === 'undefined' ?
  [() => Promise.reject(createNetworkError()), () => Promise.reject(createNetworkError())] :
  [_xhr, _xhrWithLinks];

var apiEndpoint = config.API_ENDPOINT;

/*
 * Datasets
*/
export const datasetLoad = (ownerId: string, datasetId: string): Promise<any> => xhr({
  uri: apiEndpoint + encode`/datasets/${ownerId}/${datasetId}.json`
});


/*
 * Styles
*/
export const styleLoad = (ownerId: string, styleId: string): Promise<any> => xhr({
  uri: apiEndpoint + encode`/styles/${styleId}.json`,
});


/*
 * Others
*/
export const viewLoad = (viewId: string): Promise<any> => xhr({
  uri: apiEndpoint + encode`/views/${viewId}.json`,
});
